import { render, staticRenderFns } from "./AboutUsScreen.vue?vue&type=template&id=65a15ec7&scoped=true"
import script from "./AboutUsScreen.vue?vue&type=script&lang=js"
export * from "./AboutUsScreen.vue?vue&type=script&lang=js"
import style0 from "./AboutUsScreen.vue?vue&type=style&index=0&id=65a15ec7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a15ec7",
  null
  
)

export default component.exports